import { Component, OnInit, signal } from '@angular/core';
import { ToastMessage, ToastService } from "../../toast.service";

@Component({
  selector: 'app-toast',
  standalone: false,
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css'
})
export class ToastComponent implements OnInit {

  message = signal<ToastMessage>(new ToastMessage());

  constructor(private toastService: ToastService) {

  }
  ngOnInit(): void {
    this.toastService.message.subscribe(message => {

      console.log('toast message', JSON.stringify(message));

      if (this.message()?.message === null || this.message()?.message === "") {
        this.message.set(message);
        console.log('toast done.');

        return;
      } else {
        setTimeout(() => {
          this.message.set(new ToastMessage());
        }, 10);
        setTimeout(() => {
          this.message.set(message);
        }, 500);
      }

      console.log('render toast message', message);
    });
  }


}
